export default __webpack_public_path__ + "static/media/img_7_thumb.8ba3876a.JPG";